// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2hQBx","content":"RecentSearches_content__2_eyF"};